import { AxiosInstance } from 'axios';
import { MealPatternsRepository } from '@/model/repository/manager/mealPatterns/MealPatternsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): MealPatternsRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
